import { gql } from '@apollo/client';

const INVENTORY_ORDER_FIELDS = gql`
    fragment InventoryOrderFields on orders {
        order_id
        order_number
        order_status
        order_type
        created_at
        po_number
        pickup_zip
        dropoff_zip
        order_shipper {
            business_name
        }
        itemsByOrderId {
            item_id
            quantity
            sku
            pallet {
                pallet_id
                pallet_name
                pallet_number
                warehouse_location
                warehouse_status
                logs {
                    log_id
                    pallet_id
                    created_at
                    warehouse_location
                    warehouse_status
                }
            }
            exceptions(
                where: { _and: [{ exception_type: { _eq: "ITEM" } }, { exception: { status: { _neq: "RESOLVED" } } }] }
            ) {
                created_at
                exception_type
                exception {
                    exception_id
                    status
                }
            }
            manifests {
                manifest {
                    manifest_number
                    receiving_date
                    type
                    route {
                        scheduled_delivery
                    }
                }
            }
        }
    }
`;

export const GET_ORDERS_INVENTORY = gql`
    query GetInventoryOrders($where: orders_bool_exp!, $limit: Int!) {
        orders(where: $where, order_by: [{ created_at: desc }, { order_id: desc }], limit: $limit) {
            ...InventoryOrderFields
        }
    }
    ${INVENTORY_ORDER_FIELDS}
`;

export const GET_ORDERS_INVENTORY_EXPORT = gql`
    query GetInventoryOrdersExport($where: orders_bool_exp!, $limit: Int!) {
        orders(where: $where, order_by: [{ created_at: desc }, { order_id: desc }], limit: $limit) {
            ...InventoryOrderFields
        }
    }
    ${INVENTORY_ORDER_FIELDS}
`;

export const GET_ALL_ORDER_SHIPPERS = gql`
    query GetAllOrderShippers($user_id: uuid!) {
        orders(
            where: {
                _and: [
                    { _or: [{ carrier_id: { _eq: $user_id } }, { shipper_id: { _eq: $user_id } }] }
                    {
                        order_status: {
                            _in: [
                                "pending"
                                "active"
                                "routed"
                                "claimed"
                                "inProgress"
                                "routedInProgress"
                                "complete"
                                "routedComplete"
                            ]
                        }
                    }
                    { wh_events: { action: { _ilike: "START:AWAITING" } } }
                ]
            }
            distinct_on: [shipper_id]
        ) {
            order_id
            order_number
            shipper_id
            order_shipper {
                client_id
                business_name
            }
        }
    }
`;
